import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import Carts from "./Carts";
import SelectWord from "./SelectWord";
import TextField from "@material-ui/core/TextField";
import { useDispatch, useSelector } from "react-redux";
import { setTitle } from "../../../redux/action/user";
import { setEditTitle } from "../../../redux/action/Edit"
// url

// Image
import loading from "../../../assets/img/loading.gif";
import { useHistory } from "react-router";
// Icons

export default function Flashcart(props) {
  const history = useHistory();
  // State
  const user = useSelector((state) => state.user);
  const EditState = useSelector((state) => state.Edit);
  const dispatch = useDispatch();
  const [WordList, setWordList] = useState([]);
  const [flashCartModal, setFlashCartModal] = useState(false);
  const [loadingIsOn, setloadingIsOn] = useState(false);
  const [selectedWord, setSelectedWord] = useState(
    EditState.edit && EditState.word ? EditState.word : []
  );
  const [titlef, setTitlef] = useState(
    EditState.edit && EditState.title ? EditState.title : ""
  );
  const [array, setArray] = useState([])
  //////////////////////// add flashcart Modal
  function openflashCartModal() {
    setFlashCartModal(true);
  }
  function closeflashCartModal() {
    setFlashCartModal(false);
  }
  const flashCartStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: "10",
      backgroundColor: "rgba(0 0 0 / 40%)",
    },
    content: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      margin: "auto",
      width: "70%",
      height: "340px",
      zIndex: "10",
      borderRadius: "30px",
    },
  };

  ///////////////////////// loading Modal
  // open loading function
  function openloading() {
    setloadingIsOn(true);
  }
  //close loading function
  function closeloading() {
    setloadingIsOn(false);
  }
  const loadingStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: "5000",
      backgroundColor: "rgba(0 0 0 / 40%)",
    },
    content: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      width: "400px",
      height: "155px",
      backgroundColor: "transparent",
      border: "none",
      zIndex: "5000",
      borderRadius: "30px",

    },
  };

  // function

  const handletitle = (e) => {
    EditState.edit && dispatch(setEditTitle(e.target.value));
    dispatch(setTitle(e.target.value));
    setTitlef(e.target.value);
  };

  // if (EditState.edit) {
  //   let array = []
  //   array = user.WordList
  //   selectedWord.map(word => array.forEach((item, index) => word.word === item.word && array.splice(index, 1)))
  //   setWordList(array)
  // } else {
  //   setWordList(user.WordList)
  // }

  useEffect(() => {
    // if (EditState.edit) {
      
    // } else {
      setWordList(user.WordList)
    // }
  }, [EditState.word]);


  console.log(array, "WordList   word")
  console.log(user.WordList, "user.WordList")
  return (
    <>
      <div className="container-fluid pt-3">
        <div className="row">
          <div className="col-12 title_of_questions">
            <TextField
              variant="filled"
              id="standard-basic "
              className="text_bold"
              label={<p>عنوان سوال</p>}
              onChange={handletitle}
              autoComplete="off"
              value={titlef}
            />
          </div>
          <div className="col-12">
            <div className="text-right">
              <span className="text_bold">
                فلـش کارت‌هـا را از بانک کلمات انتخاب کنید و پاسخ صحیح را علامت
                بزنید.
              </span>
            </div>
          </div>
          <div className="col-12 pt-4 ltr">
            <div className="row">
              <Carts
                openflashCartModal={openflashCartModal}
                setSelectedWord={setSelectedWord}
                selectedWord={selectedWord}
                Words={user.WordList}
                imginApiQuestion={props.imginApiQuestion}
                item={props.item}
              />
            </div>
          </div>
        </div>
      </div>
      {flashCartModal && (
        <Modal
          isOpen={flashCartModal}
          onRequestClose={closeflashCartModal}
          style={flashCartStyle}
          closeTimeoutMS={200}
        >
          <SelectWord
            closeflashCartModal={closeflashCartModal}
            Words={WordList}
            selectedWord={selectedWord}
            setSelectedWord={setSelectedWord}
            imginApiQuestion={props.imginApiQuestion}
          />
        </Modal>
      )}
      {loadingIsOn && (
        <Modal isOpen={loadingIsOn} style={loadingStyle}>
          <div class="d-flex justify-content-center">
            <img className="w-25 h-25" src={loading} alt="" />
          </div>
        </Modal>
      )}
    </>
  );
}
